import { ActionsMenu as FoundationActionsMenu, foundationActionsMenuTemplate as template, } from '@genesislcap/foundation-ui';
import { zeroActionsMenuStyles as styles } from './actions-menu.styles';
/**
 * @tagname %%prefix%%-actions-menu
 */
export class ActionsMenu extends FoundationActionsMenu {
}
/**
 * The Zero Actions Menu
 *
 * @public
 * @remarks
 * HTML Element: \<zero-actions-menu\>
 */
export const zeroActionsMenu = ActionsMenu.compose({
    baseName: 'actions-menu',
    styles,
    template,
});
